import React, { useState } from "react";
import { addSearchHistory } from "../../Services/api";

import hub_icon from "../../Assets/Images/icons/hublable.png";
import { useNavigate } from "react-router-dom";
import { IoLocationSharp } from "react-icons/io5";


const HubProfileCard = (item) => {

    const navigate = useNavigate();
    let data = item?.data
    function openKitchenProfile(vendorId) {
        let param = {
            search_vendor_id: vendorId,
        };
        addSearchHistory(param).then((res) => {
            if (res.data?.status == "1") {
                navigate(`/kitchen_ticket_list/${vendorId}`, { state: { fromPage: "search" } });
            }
        });
    } 

    return (
        <div className="storeCards bg-white d-flex mb-4" role="button" onClick={() => openKitchenProfile(data?.vendor_id)}>
            <div className="primary-bg-light rounded-3 d-flex justify-content-center align-items-center" style={{ height: "71px", width: "110px" }}>
                <span className="fs-24 primary-text ff-poppins-medium">H{data?.hub_name.match(/\d+$/)?.[0]}</span>
            </div>
            <div style={{ width: "100%" }} className="ms-2">
                <div className="ff-poppins-medium text-dark fs-14">{data?.hub_name}</div>
                <div className="d-flex mt-1">
                    <div className="ff-poppins-regular secondary-text  fs-10 d-flex align-items-center">
                        <div className="bullets me-2"></div>MID {data?.vendor_id}
                    </div>
                    <div className="ff-poppins-regular secondary-text ms-3 fs-10 d-flex align-items-center ">
                        <div className="bullets me-1"></div>
                        {data?.vendor_company_name}
                    </div>
                </div>
                <div className="d-flex justify-content-between mt-3 secondary-text-1">
                    <div className="ff-poppins-medium text-dark fs-10 d-flex align-items-center">{data?.distance}</div>
                    <div className="d-flex">
                        <IoLocationSharp className="fs-13 secondary-text-2" />
                        <p className="ff-poppins-regular fs-10 p-0 m-0">{data?.vendor_area}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HubProfileCard;
